export class FindNode {
  public static findNode(tree, node): any {
    let search = [tree];
    let keys = null;
    let result = [];
    while (search.length > 0) {
      let next = search.shift();
      if (Array.isArray(next)) {
        for (let item of next) {
          search.push(item);
        }
      } else if (!(Object.prototype.toString.call(next) === "[object String]")) {
        keys = Object.keys(next);
        for (let key of keys) {
          if (key == node) {
            result.push(next[key]);
          }
          search.push(next[key]);
        }
      }
    }
    return result;
  }
}
